module.exports = __webpack_public_path__ + "img/about-hub.png?d73e1082da21ebbd2a717e756a599b39";